export enum StorageDocumentoStatus {
	APPROVED,
	DENIED,
	REQUESTED,
	SENT,
	CANCELED = -1
}
